<app-progress-bar class="progress-bar-top-fixed" mode="indeterminate"></app-progress-bar>
<div class="container">
    <div class="center-form-container">
        <router-outlet></router-outlet>
    </div>
</div>